export default __webpack_public_path__ + "static/media/SAL9.fc79dd88.jpg";